import React, { useState } from "react";

export default function RatingScale({ value, onChange, disabled, size = "md", testIdPrefix = "rating" }) {
    const [popIdx, setPopIdx] = useState(null);
    const nums = Array.from({ length: 10 }, (_, i) => i + 1);

    const handle = (n) => {
        if (disabled) return;
        setPopIdx(n);
        setTimeout(() => setPopIdx(null), 320);
        onChange?.(n);
    };

    const colorFor = (n) => {
        if (n <= 3) return "bg-[#FFB8D1]";
        if (n <= 6) return "bg-[#B8E1FF]";
        return "bg-[#FFE55C]";
    };

    const sizeCls = size === "sm" ? "w-9 h-9 text-sm" : "w-11 h-11 text-base";

    return (
        <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-scale`}>
            {nums.map((n) => {
                const active = value === n;
                return (
                    <button
                        key={n}
                        onClick={() => handle(n)}
                        disabled={disabled}
                        data-testid={`${testIdPrefix}-btn-${n}`}
                        aria-label={`Rate ${n}`}
                        className={[
                            sizeCls,
                            "rounded-lg border-2 border-[#0A0A0A] font-black flex items-center justify-center",
                            active ? `${colorFor(n)} shadow-[3px_3px_0px_#0A0A0A]` : "bg-white hover:bg-[#FFFDF7]",
                            disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
                            popIdx === n ? "pop" : "",
                        ].join(" ")}
                    >
                        {n}
                    </button>
                );
            })}
        </div>
    );
}
